export function _getShapeById(data, shapeId) {
    const shape = data.shapes.byId[shapeId];
    if (shape === undefined) {
        console.warn("Shape not found.");
    }
    return shape;
}
